import { render, staticRenderFns } from "./StudentProgressionRead.vue?vue&type=template&id=1c42a82c"
import script from "./StudentProgressionRead.vue?vue&type=script&lang=js"
export * from "./StudentProgressionRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports